/* TAB分類 / DETAIL更多選項 / 折扣 模板*/
<template>
  <cus-dialog>
    <template v-slot:body>
      <div class="list-wrap">
        <cus-button
          v-for="(item, index) in renderList"
          :key="index"
          :text="item.label"
          :selected="checkSelected(item.value)"
          :disabled="item.disable"
          @click="handleClick(item)"
        ></cus-button>
        <cus-page
          v-if="totalPage > 1"
          :totalPage="totalPage"
          v-model:currentPage="currentPage"
          style="grid-area: 5/1/6/5"
        ></cus-page>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <!-- 折扣相關的dialog不擋空值 -->
        <cus-button
          v-if="name === 'discount' || name === 'entertain'"
          text="選擇"
          color="blue"
          :width="50"
          @click="submit(choose)"
        ></cus-button>
        <!-- tab button / detail button -->
        <cus-button
          v-else
          text="選擇"
          color="blue"
          :width="50"
          @click="submit(choose)"
          :disabled="!choose"
        ></cus-button>
      </div>
    </template>
  </cus-dialog>
</template>
<script>
import { ref, inject, watch, computed } from 'vue';
import CusButton from '../../library/CusButton.vue';
export default {
  components: { CusButton },
  name: 'more-select',
  setup() {
    //接受provide值
    const dialogVisible = inject('dialogVisible', false);
    const name = inject('name');
    const close = inject('close');
    const submit = inject('submit');
    const { list } = inject('list');
    const { cusProps } = inject('cusProps');
    //設定參數
    const choose = ref(null);
    const currentPage = ref(1);
    const totalPage = computed(() => Math.ceil(list.length / 16));
    const renderList = computed(() => list.slice((currentPage.value - 1) * 16, currentPage.value * 16));
    //設定初始值
    if (dialogVisible) {
      if (!cusProps.type) cusProps.type = 'single'; //預設為單選
      // console.log('cusProps.init', cusProps.init);
      switch (cusProps.type) {
        case 'single':
          {
            if (!cusProps.init) break;
            const index = list.findIndex(
              (e) =>
                e.value === cusProps.init ||
                e.value === cusProps.init?.value ||
                e.value === cusProps.init[0] ||
                e.value === cusProps.init[0]?.value
            );
            if (index < 0) choose.value = null;
            else choose.value = JSON.parse(JSON.stringify(cusProps.init));
          }
          break;
        case 'multiple':
          if (!cusProps.init) choose.value = [];
          else choose.value = JSON.parse(JSON.stringify(cusProps.init));
          break;
      }
    }
    //恢復初始值
    watch(dialogVisible, () => {
      choose.value = null;
      currentPage.value = 1;
    });

    //處理選中狀態
    const checkSelected = (itemValue) => {
      switch (cusProps.type) {
        case 'single':
          if (!choose.value) break;
          if (
            choose.value?.value === itemValue ||
            choose.value === itemValue ||
            choose.value[0] === itemValue ||
            choose.value[0]?.value === itemValue
          )
            return true;
          break;
        case 'multiple':
          if (choose.value?.findIndex((e) => e.value === itemValue || e === itemValue) !== -1) return true;
          break;
      }
      return false;
    };

    //點擊品項
    const handleClick = (item) => {
      switch (cusProps.type) {
        case 'single':
          if (!choose.value) choose.value = item;
          else if (
            choose.value?.value === item.value ||
            choose.value === item.value ||
            choose.value[0]?.value === item.value ||
            choose.value[0] === item.value
          )
            choose.value = null;
          else choose.value = item;
          break;
        case 'multiple':
          {
            if (!choose.value) choose.value = [];
            const index = choose.value?.findIndex((e) => e.value === item.value || e === item.value);
            if (index === -1) choose.value?.push(item);
            else choose.value?.splice(index, 1);
          }
          break;
      }
    };
    return {
      name,
      close,
      submit,
      cusProps,
      choose,
      currentPage,
      totalPage,
      renderList,
      checkSelected,
      handleClick,
    };
  },
};
</script>
<style lang="scss" scoped>
.list-wrap {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr) 0.6fr;
}
</style>
